export default __webpack_public_path__ + "static/media/news-4.ffe69401.jpg";